import ErrorHandler from "./errorHandler";
import labels from "./errorLabels";

const {
  ERROR_PAGE: { NO_ACCESS },
} = labels;

const NoAccess = () => {
  return <ErrorHandler errorCase={NO_ACCESS} />;
};

export default NoAccess;
